import type { Query } from '@vrplatform/graphql';
import { type QueryKeyUnion, useQuery } from './react-query';

type Params<TArgs, TData> = {
  queryKey: QueryKeyUnion | QueryKeyUnion[];
  query: (
    q: Query,
    args: TArgs & {
      order_by: any[];
      offset: number;
      groupBy?: string[];
      limit: number;
    }
  ) => { list: TData[]; aggregate: number };
  args: TArgs;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  sorting: {
    id: string;
    desc: boolean;
  }[];
  groupBy?: string[];
  skip?: boolean;
  refetchOnWindowFocus?: boolean;
};

export function usePaginatedQuery<TArgs extends object, TData>({
  query,
  queryKey,
  args,
  pagination,
  sorting,
  skip,
  groupBy,
  refetchOnWindowFocus,
}: Params<TArgs, TData>) {
  return useQuery(query, {
    queryKey,
    variables: {
      ...args,
      limit: pagination.pageSize,
      offset: pagination.pageIndex * pagination.pageSize,
      groupBy,
      order_by: sorting.map((sort) => ({
        [sort.id]: sort.desc ? 'desc_nulls_last' : 'asc_nulls_last',
      })),
    },
    keepPreviousData: true,
    refetchOnWindowFocus,
    skip,
  });
}
